import { render } from "./event_detail_wholesale.vue?vue&type=template&id=cc7768d0&scoped=true"
import script from "./event_detail_wholesale.vue?vue&type=script&lang=js"
export * from "./event_detail_wholesale.vue?vue&type=script&lang=js"

import "./event_detail_wholesale.vue?vue&type=style&index=0&id=cc7768d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc7768d0"]])

export default __exports__